export enum KPIComparison {
  NONE = 'none',
  DISCOUNT_HIGHER = 'discountHigher',
  DISCOUNT_LOWER = 'discountLower',
  SIMPLIFIED = 'simplified',
  STOCK = 'stock',
}
